<template>
  <div class="app-personal-data-wrapper">
    <ViewPersonalData
      :current-customer="currentCustomer"
      v-if="getView === 'viewPersonalData'"
      :current-evn-configuration="currentEvnConfiguration"
    >
      <template v-for="slot in possibleChildSlotsFor('View')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ViewPersonalData>
    <ChangePersonalData
      v-if="getView === 'changePersonalData'"
      :current-customer="currentCustomer"
      :current-evn-configuration="currentEvnConfiguration"
      @refresh="refreshQuery"
      ref="change"
    >
      <template v-for="slot in possibleChildSlotsFor('Change')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangePersonalData>
    <Success
      v-if="getView === 'personalDataChangeSuccess'"
      :show-logout="true"
      @done="goToViewState">
      <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
    <Success
      v-if="getView === 'SendVerificationMail'"
      :show-logout="true"
      @done="goToViewState">
      <template v-for="slot in possibleChildSlotsFor('EmailSuccess')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
  </div>
</template>

<script>
import ViewPersonalData from '@/components/process/generic/PersonalData/bild/View.vue'
import ChangePersonalData from '@/components/process/generic/PersonalData/bild/Change.vue'
import Success from '@/components/generic/Success.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'

export default {
  name: 'PersonalDataWrapper',
  mixins: [
    transaction('personalData'),
    slotProxy()
  ],
  data () {
    return {
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        alternativePhone: '',
        phoneBookEntry: {
          phoneBookEntryDirectoryAssistance: '',
          phoneBookEntryElectronic: '',
          phoneBookEntryKey: '',
          phoneBookEntryPrint: ''
        },
        email: ''
      },
      currentEvnConfiguration: {
        evn: ''
      }
    }
  },
  computed: {
    ...mapGetters('personalData', [
      'getView'
    ])
  },
  created: function () {
    this.goToViewState()
  },
  methods: {
    ...mapMutations('personalData', [
      'changeView'
    ]),
    goToViewState () {
      this.changeView('viewPersonalData')
    },
    refreshQuery () {
      this.$apollo.queries.currentCustomer.refetch()
      this.$apollo.queries.currentEvnConfiguration.refetch()
    }
  },
  components: {
    Success,
    ChangePersonalData,
    ViewPersonalData
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query personalData{
          currentCustomer {
            salutation,
            firstName,
            birthDate,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            },
            alternativePhone,
            phoneBookEntry {
                phoneBookEntryDirectoryAssistance,
                phoneBookEntryElectronic,
                phoneBookEntryKey,
                phoneBookEntryPrint
            }
            email
          }
        }`, this, 'currentCustomer'
      )
    },
    currentEvnConfiguration: function () {
      return wrapQuery(
        gql`query personalData {
          currentEvnConfiguration {
              evn
          }
        }`, this, 'currentEvnConfiguration'
      )
    }
  }
}
</script>
